module.exports = __webpack_public_path__ + "static/media/motivation.4abb56d3.png";